import * as ng from 'angular';
import { DropboxSaver } from './dropbox-saver.directive';


export const DropboxSaverModule: string =
    ng.module('dropbox-saver', [
    ])
        .directive('dropboxSaver', DropboxSaver)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/dropbox-saver/dropbox-saver.module.ts